export default __webpack_public_path__ + "static/media/electrocardiogram.ad219560.png";